import { clone, dissoc, path, pathOr } from 'ramda';
import {
	CLEAR_ACTIVITIES,
	CLEAR_ACTIVITY_UPDATE_ERRORS,
	CLEAR_ACTIVITY_CREATE_ERRORS,
	CREATE_ACTIVITY_SUCCEEDED,
	CREATE_ACTIVITY_FAILED,
	CREATE_ACTIVITY,
	FETCH_ACTIVITIES_SUCCEEDED,
	FETCH_ACTIVITIES_FAILED,
	FETCH_ACTIVITIES_TODAY_SUCCEEDED,
	FETCH_ACTIVITIES_THIS_WEEK_SUCCEEDED,
	GET_ACTIVITIES,
	UPDATE_ACTIVITY_SUCCEEDED,
	UPDATE_ACTIVITY_FAILED,
	UPDATE_ACTIVITY,
	DELETE_ACTIVITY_SUCCEEDED,
	DELETE_ACTIVITY_FAILED,
	DELETE_ACTIVITY,
} from './activity.action';
import { activitiesInitialState } from './activity.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const activityReducer = (state = activitiesInitialState, action) => {
	switch (action.type) {
		case CLEAR_ACTIVITIES: {
			return {
				...state,
				entities: activitiesInitialState.entities,
				isDirty: false,
				totalToDisplay: 0,
				skip: 0,
			};
		}

		case CLEAR_ACTIVITY_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_ACTIVITY_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_ACTIVITIES: {
			return createPendingState(state, 'pendingFetch');
		}

		case UPDATE_ACTIVITY: {
			return createPendingState(state, 'pendingUpdate');
		}

		case CREATE_ACTIVITY: {
			return createPendingState(state, 'pendingCreate');
		}

		case DELETE_ACTIVITY: {
			return createPendingState(state, 'pendingDelete');
		}

		case FETCH_ACTIVITIES_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case UPDATE_ACTIVITY_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case CREATE_ACTIVITY_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case DELETE_ACTIVITY_FAILED: {
			return createErrorState(state, 'pendingDelete', 'deleteError', action.payload);
		}

		case FETCH_ACTIVITIES_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			const newTotal = path(['payload', 'total'], action);
			const newSkip =
				newTotal >= state.skip ? { skip: action.payload && action.payload.skip + 10 } : {};

			return {
				...state,
				entities,
				pendingFetch: false,
				isDirty: false,
				totalToDisplay: newTotal,
				...newSkip,
			};
		}

		case FETCH_ACTIVITIES_TODAY_SUCCEEDED: {
			return {
				...state,
				activitiesToday: action.payload,
			};
		}

		case FETCH_ACTIVITIES_THIS_WEEK_SUCCEEDED: {
			return {
				...state,
				activitiesThisWeek: action.payload,
			};
		}

		case UPDATE_ACTIVITY_SUCCEEDED: {
			const updatedActivityId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedActivityId) {
				newState.entities = {
					...state.entities,
					[updatedActivityId]: action.payload,
				};
			}

			return newState;
		}

		case DELETE_ACTIVITY_SUCCEEDED: {
			const deletedActivityId = path(['payload', '_id'], action);
			const newState = {
				...state,
				isDirty: true,
				pendingDelete: false,
			};

			if (deletedActivityId) {
				newState.entities = dissoc(deletedActivityId, state.entities);
			}

			return newState;
		}

		case CREATE_ACTIVITY_SUCCEEDED: {
			return {
				...state,
				isDirty: true,
				pendingCreate: false,
			};
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/activities/activity.reducer.js